// extracted by css-extract-rspack-plugin
export default {"table":"table-hxnu_0","rowHighlighted":"rowHighlighted-Kb8etf","reportTable":"reportTable-Ex6IGX"};